import { render, staticRenderFns } from "./ModuleAccordion.vue?vue&type=template&id=3bdace0a&scoped=true&"
import script from "./ModuleAccordion.vue?vue&type=script&lang=js&"
export * from "./ModuleAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ModuleAccordion.vue?vue&type=style&index=0&id=3bdace0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdace0a",
  null
  
)

export default component.exports